import React from "react";
import colloredRiple from "../../assets/values/colored-ripple.svg";
import icLogic from "../../assets/values/ic-logic.svg";
import icCapi from "../../assets/values/ic-capi.svg";
import cawiCapi from "../../assets/values/cawi-capi.svg";
import icTouch from "../../assets/values/ic-touch-id.svg";
import icRaport from "../../assets/values/ic-raport.svg";
import Animate from "../Animate";

const icons = {
  "colored-ripple.svg": colloredRiple,
  "ic-logic.svg": icLogic,
  "ic-capi.svg": icCapi,
  "cawi-capi.svg": cawiCapi,
  "ic-touch-id.svg": icTouch,
  "ic-raport.svg": icRaport,
};

const Values = ({ t, values }) => (
  <div id="values" className="landing-container-values">
    <div className="landing-layout">
      <div className="landing-page-values">
        <div className="landing-values-header">
          <Animate>
            <h2 className="landing-section-title">{t("landing.values.title")}</h2>
          </Animate>
          <p className="landing-section-text">{t("landing.values.subtitle")}</p>
        </div>
        <div className="landing-boxes">
          {values.map(({ title, text, icon }, index) => (
            <div key={index} className="landing-boxes-container">
              <div className="landing-boxes-container-elements">
                <img src={icons[icon]} alt="" />
                <p className="landing-boxes-title">{title}</p>
                <div className="landing-boxes-line"></div>
                <p className="landing-boxes-text">{text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default Values;
